// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__XAzW1","wrapper":"Modal_wrapper__obOrb","header":"Modal_header__K3mWC","content":"Modal_content__v+fLJ"};